import { TFunction } from "i18next";

import { AmbulanzResponse, AmbulanzType } from "@/api";
import { assertUnreachable } from "@/common/helper/commonHelper";

function getAmbulanzTypeLabel(type: AmbulanzType, t: TFunction): string {
  switch (type) {
    case AmbulanzType.Ambulanz:
      return t("ambulanzes.types.ambulanz");
    case AmbulanzType.Callback:
      return t("ambulanzes.types.callback");
    case AmbulanzType.Sms:
      return t("ambulanzes.types.sms");
    default:
      return assertUnreachable(type);
  }
}

export function formatAmbulanzLabel(ambulanz: AmbulanzResponse, t: TFunction): string {
  const typeLabel = getAmbulanzTypeLabel(ambulanz.type, t);
  const ambulanzNumber = (ambulanz.ambulanzNumber ?? "").trim();

  return ambulanzNumber ? `${typeLabel} - ${ambulanzNumber}` : typeLabel;
}
